<template>
  <a-layout-sider v-model="collapsed" :collapsible="true" :trigger="null" theme="dark" width="200">
    <div @click="toggleCollapsed">
      <a v-show="!collapsed" class="ant-menu-app" style="font-weight: 600">
        {{ $t(currentApp) }}
        <a-icon type="menu-fold" />
      </a>
      <div v-show="collapsed" class="ant-menu-inline-collapsed">
        <li
          class="item a ant-menu-item"
          style="padding-left: 24px; text-align:center; height: 50px; line-height: 50px;"
        >
          <a style="color: #4a90e2;"><a-icon type="menu-unfold"/></a>
        </li>
      </div>
    </div>
    <a-menu
      v-model="activeMenu"
      mode="inline"
      :inline-collapsed="collapsed"
      style="height: calc(100% - 71px)"
      theme="dark"
    >
      <template v-if="appRoutes && appRoutes[0] && appRoutes[0].children">
        <template v-for="(route, index) in appRoutes[0].children">
          <template v-if="route.children && route.children.length > 0">
            <a-sub-menu
              style="min-height: 50px; margin: 0; margin-bottom: 6px;"
              :key="route.data.path + index"
            >
              <span
                class="title-space-sub"
                style="line-height: 50px; font-size: 15px; font-weight: 600;"
                slot="title"
              >
                <a-icon :type="route.data.source" />
                <span>
                  <div class="title-space-aa">
                    {{ $t(route.data.code) || route.title }}
                  </div>
                </span>
              </span>
              <a-menu-item
                style="margin: 0!important;  background-color: #223948"
                v-for="child in route.children"
                :key="child.data.path"
                class="item"
              >
                <router-link :to="child.data.path" style="display: inline-block; margin-left:10px;">
                  <div class="title-space-in">
                    {{ $t(child.data.code) || route.title }}
                  </div>
                </router-link>
                <a-icon
                  v-if="!isInDrawer(child.data.path)"
                  type="star"
                  class="icon"
                  @click.stop="
                    putInDrawer({
                      app: $t(route.data.code) || route.title,
                      icon: route.data.source,
                      name: currentApp,
                      route: child
                    })
                  "
                />
                <a-icon
                  v-else
                  type="star"
                  theme="filled"
                  class="icon"
                  style="display: block; color: #ffc53d"
                  @click.stop="takeFromDrawer(child.data.path)"
                />
              </a-menu-item>
            </a-sub-menu>
          </template>

          <template v-else>
            <a-menu-item
              style="height: 50px; line-height: 50px; margin: 0!important; font-size: 15px; font-weight: 600;  margin-bottom: 6px;"
              :key="route.data.path"
              class="item a"
            >
              <a-icon :type="route.data.source" @click="goRouter(route.data.path)" />
              <span v-if="collapsed">
                <router-link :to="route.data.path" style="display: inline-block">
                  <div class="title-space">
                    {{ $t(route.data.code) || route.title }}
                  </div>
                </router-link>
              </span>
              <router-link v-else :to="route.data.path" style="display: inline-block;color:#fff">
                <div class="title-space">
                  {{ $t(route.data.code) || route.title }}
                </div>
              </router-link>
              <template v-if="!collapsed">
                <a-icon
                  v-if="!isInDrawer(route.data.path)"
                  type="star"
                  class="icon"
                  @click.stop="
                    putInDrawer({
                      app: route.data.code || route.title,
                      icon: route.data.source,
                      name: currentApp,
                      route: route
                    })
                  "
                />
                <a-icon
                  v-else
                  type="star"
                  theme="filled"
                  class="icon"
                  style="display: block; color: #ffc53d"
                  @click.stop="takeFromDrawer(route.data.path)"
                />
              </template>
            </a-menu-item>
          </template>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      collapsed: false
    }
  },
  computed: {
    ...mapGetters(['appRoutes', 'drawer', 'currentApp']),
    primaryPath() {
      return '/' + this.$route.path.split('/')[1]
    },
    activeMenu: {
      get() {
        return [this.$route.path]
      },
      set(newValue) {
        console.info()
      }
    },
    /* activeMenu() {
      return [this.$route.path]
    },*/
    isInDrawer() {
      return function(path) {
        return this.drawer.filter((item) => item.link === path).length > 0
      }
    }
  },
  methods: {
    ...mapActions('user', ['putInDrawer', 'takeFromDrawer']),
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    goRouter(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
.menu-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  text-align: center;
  padding: 24px 16px 16px 24px;
  border-right: 1px solid #e8e8e8;
  span {
    color: #1890ff;
    line-height: 1;
  }
}
.collapse {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(100%, -50%);
  z-index: 10;
  cursor: pointer;
}
.item {
  position: relative;
  .icon {
    display: none;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
  &:hover {
    .icon {
      display: inline;
      color: #ffc53d;
    }
  }
}

.ant-menu-app {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  margin: 8px 0;
  font-size: 20px;
  color: #4a90e2;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.title-space-sub {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.title-space-aa {
  line-height: 20px;
  word-break: break-word;
  width: 100px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.title-space {
  line-height: 20px;
  word-break: break-word;
  width: 125px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.title-space-in {
  line-height: 15px;
  word-break: break-word;
  width: 95px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/deep/ .ant-menu-root {
  overflow-y: auto;
  overflow-x: hidden;
}

.ant-layout-sider,
.ant-menu-dark,
/deep/ .ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background-color: #294556;
  box-shadow: 0 0 0 0;
  border: none;
}
.ant-menu-submenu-selected {
  color: #3a7fbc !important;
}
.ant-menu-dark {
  color: rgba(255, 255, 255, 1);
}

// /deep/ .ant-menu-inline {
//   background-color: rgb(34, 58, 72)!important;
// }

/deep/ .ant-menu-submenu-inline .ant-menu-submenu-title {
  margin: 0;
  height: 50px !important;
  line-height: 50px !important;
}

/deep/ .ant-menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/deep/ .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/deep/ .ant-menu-submenu-title:hover {
  background-color: rgb(48, 84, 114) !important;
}

/deep/ .ant-menu-item:hover {
  background-color: rgb(48, 84, 114) !important;
}

/deep/ .ant-menu-item-selected {
  background-color: rgb(74, 144, 226) !important;
}

/deep/ .ant-menu-item-selected:hover {
  background-color: rgb(74, 144, 226) !important;
}
</style>
